module.exports = __webpack_public_path__ + "media/images/design/images/icon_insta-05d9dfca1d5b13c602f7ab9789414935.jpg";